/**
 * Function that uses object spread to merge two objects into
 * a single object.
 * @param {object} state - The current state.
 * @param {object} diff - The changes which should be made to the current state.
 * @returns {object} - New state object.
 */
export default function createReducer(state, diff) {
  return { ...state, ...diff }
}
